import { OrderItemType } from 'types/pwcOrder';

import { makeLabels } from 'utils/i18n';

export const KEYS = {
  DELIVERY: OrderItemType.Delivery,
};

const MESSAGES_NAMESPACE = 'components.orderItem';

export const LABELS = makeLabels(
  {
    DELIVERY_FEE: ['deliveryFee', 'Delivery Fee'],
    ITEM_NAME_WITH_COUNT: ['itemNameWithCount', '{{itemCount}}. {{itemName}}'],
  },
  MESSAGES_NAMESPACE,
);

export default LABELS;
